import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Material UI Icon
import { useMediaQuery } from '@mui/material';
import '../Components/IconWalk.css'; // Import the CSS file
import DogeCoin from '/Images/Doge.png';
import Kaia from '/Images/Kaia.png';
import Ethereum from '/Images/Etherium.png';
import Bitcoin from '/Images/image 220.png';
import Solana from '/Images/Solana.png';
import Cardano from '/Images/Cardano.png';
import BNB from '/Images/BNB.png';
import DOT from '/Images/DOT.png';
import MATIC from '/Images/MATIC.png';
import TRX from '/Images/TRX.png';
import XRP from '/Images/XRP.png';
import { textAlign } from '@mui/system';

const Icon = () => {

  const styles = {
    exploreMore: {
      textAlign: 'center',
      fontSize: '2rem',
      display: 'flex',
      alignItems: 'center',
      padding: '20px',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    arrow: {
      marginLeft: '5px',
    },
  };

  const isMobile = useMediaQuery('(max-width: 767px)');
  const icons = [
    /* { name: 'Cardano', symbol: 'ADA', image: Cardano }, */
    { name: 'Bitcoin', symbol: 'BTC', image: Bitcoin },
    { name: 'Solana', symbol: 'SOL', image: Solana },
    { name: 'Ethereum', symbol: 'ETH', image: Ethereum },
    { name: 'Kaia', symbol: 'KAIA', image: Kaia },
    { name: 'BNBSmartChain', symbol: 'BNB', image: BNB },
/*    { name: 'Polkadot', symbol: 'DOT', image: DOT }, */
    { name: 'Polygon', symbol: 'MATIC', image: MATIC },
    { name: 'Tron', symbol: 'TRX', image: TRX },
    { name: 'Ripple', symbol: 'XRP', image: XRP },
  ];

  return (
    <div>
    <div className="scroll-container">
      <div className="scroll-text">
        {icons.map((icon, index) => (
          <div className="icon-wrapper" key={index}>
            <img src={icon.image} alt={icon.name} className="icon-image" />
            <p className="icon-name">{icon.name}</p>
          </div>
        ))}
        {/* Duplicate icons for seamless scrolling */}
        {icons.map((icon, index) => (
          <div className="icon-wrapper" key={`dup-${index}`}>
            <img src={icon.image} alt={icon.name} className="icon-image" />
            <p className="icon-name">{icon.name}</p>
          </div>
        ))}
      </div>
    </div>
    <Link to="/supported-coins" style={{ textDecoration: 'none' }}>
      <div style={styles.exploreMore}>
        Supported Coins
        <ArrowForwardIcon style={styles.arrow} />
      </div>
    </Link>
    </div>
  );
};

export default Icon;
